'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _DatePicker = require('../../../inputs/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ISSUE put style local
function DateCondition(props) {
  var linkState = props.linkState,
      value = props.value,
      style = props.style;
  var equal = value.equal,
      gte = value.gte,
      lte = value.lte;


  var useEqual = !!equal;
  var useRange = !!gte || !!lte;

  return _react2.default.createElement(
    'div',
    { className: style.searchWidget },
    _react2.default.createElement(
      'span',
      null,
      '\uFF1D'
    ),
    _react2.default.createElement(
      'div',
      { className: style['date-container'] },
      _react2.default.createElement(_DatePicker2.default, _extends({}, linkState('equal'), { disabled: useRange }))
    ),
    _react2.default.createElement(
      'span',
      null,
      '\uFF0C'
    ),
    _react2.default.createElement(
      'div',
      { className: style['date-container'] },
      _react2.default.createElement(_DatePicker2.default, _extends({}, linkState('gte'), { disabled: useEqual }))
    ),
    _react2.default.createElement(
      'span',
      null,
      '\uFF5E'
    ),
    _react2.default.createElement(
      'div',
      { className: style['date-container'] },
      _react2.default.createElement(_DatePicker2.default, _extends({}, linkState('lte'), { disabled: useEqual }))
    )
  );
}
var object = _propTypes2.default.object,
    func = _propTypes2.default.func;

DateCondition.propTypes = {
  linkState: func.isRequired,
  value: object.isRequired,
  style: object.isRequired
};

function toQueryString(value) {
  return 'Date(\'' + value.toISOString() + '\')';
}
DateCondition.buildQuery = function buildDateQuery(state) {
  var equal = state.equal,
      gte = state.gte,
      lte = state.lte;


  if (!equal && !gte && !lte) return null;

  var operation = {};
  if (equal) {
    // not null or ''
    operation.$gte = (0, _moment2.default)(equal).startOf('day');
    operation.$lte = (0, _moment2.default)(equal).endOf('day');
  } else {
    if (gte) {
      operation.$gte = (0, _moment2.default)(gte).startOf('day');
    }
    if (lte) {
      operation.$lte = (0, _moment2.default)(lte).endOf('day');
    }
  }
  return (0, _mapValues2.default)(toQueryString)(operation);
};

exports.default = DateCondition;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/DateCondition.js
// module id = 1694
// module chunks = 0